import React from "react";
import { MultiSelect } from "primereact/multiselect";

interface StationFilterProps {
  stationIds: string[];
  selected: string[] | null;
  onChange: (ids: string[] | null) => void;
  disabled?: boolean;
}

const StationFilter: React.FC<StationFilterProps> = ({
  stationIds,
  selected,
  onChange,
  disabled,
}) => {
  const options = stationIds.map((id) => ({ label: id, value: id }));

  return (
    <MultiSelect
      value={selected}
      onChange={(e) => onChange(e.value?.length > 0 ? e.value : null)}
      options={options}
      placeholder="All Stations"
      display="chip"
      disabled={disabled}
      className="w-full md:w-20rem"
      filter
    />
  );
};

export default StationFilter;
